import React, { useState } from "react";
import styles from "./index.module.scss";
import { l2PersonalHealthRecordsOPtions } from "../../../RpmModule/Constants/Menus/ConstantMenus";
import { getKeysOfObject } from "../../../../Helpers/helperFunctions";
import Lifestyle from "./ChildComponents/Lifestyle/Index";
import Medications from "./ChildComponents/Medication/Index";

const HealthRecords = () => {

    const navItems = {
        lifestyle: {
          name: "Lifestyle Conditions & Pre-Existing Conditions",
          key: "lifestyle",
          component: <Lifestyle/>,
        },
        medication: {
          name: "Medications & Allergies",
          key: "medication",
          component: <Medications/>,
        },
      };

      

  let [activeTop, setActiveTop] = useState(navItems.lifestyle.key);


  return (
    <div className="patient-medical-container_header">
      <div className={styles.l3Nav}>
        <ul>
          {getKeysOfObject(navItems).map((element, key) => {
            return (
              <>
                <li
                  key={key}
                  className={
                    activeTop === navItems[element]?.key
                      ? styles.l3NavActive
                      : null
                  }
                  onClick={() => {
                    setActiveTop(navItems[element]?.key);
                  }}
                >
                  {navItems[element]?.name}
                </li>
                {key < getKeysOfObject(navItems).length - 1 ? " | " : null}
              </>
            );
          })}
        </ul>
      </div>
      {navItems[activeTop]?.component}
    </div>
  );
};

export default HealthRecords;
